import { Box, useBreakpointValue } from '@chakra-ui/react';
import { CloudinaryGif } from '@time-line/components/common';
import type { CloudinaryVideo } from '@time-line/components/types';
import { useState } from 'react';
import { useEffectOnce } from 'react-use';

export const Video = ({
  videos,
}: {
  videos: { desktop: CloudinaryVideo; mobile: CloudinaryVideo };
}) => {
  const [canPlay, setCanPlay] = useState(false);

  const cloudinaryId =
    useBreakpointValue<string>(
      {
        base: videos.mobile.cloudinaryId,
        md: videos.desktop.cloudinaryId,
      },
      {
        fallback: videos.desktop.cloudinaryId,
      },
    ) || videos.desktop.cloudinaryId;

  useEffectOnce(() => {
    setCanPlay(true);
  });

  return (
    <Box position="fixed" inset={0}>
      <CloudinaryGif
        cloudinaryId={cloudinaryId}
        canPlay={canPlay}
        videoProps={{ loop: false }}
      />
    </Box>
  );
};
